export default "__VITE_ASSET__BUB01Yq___"